import ApiHelper from "./ApiHelper.ts";
import { Paths } from "./Paths.ts";


export class DataService {
    async uploadImage(file) {
        return ApiHelper.postWithFiles('/upload', file)
    }
    // async getFullSatiUser(user, code) {
    //     return ApiHelper.get(`${Paths.full_sati_user}${user}/${code}`,)
    // }
    // async getWalletUserAuthNonce(public_address) {
    //     return ApiHelper.get(`${Paths.wallet_user}${public_address}/auth_nonce`)
    // }
    /**
     * 
     * @param public_address 
     * @param body 
     *
        {
        "signature": "I68h00eZZuaclK7HD2szOEL6fC2+MnAcpjIjCqkh/ZCtWRviau1t0H41EXYp1SWlHOVW0YxEL7N8/bAoKKDZZMI=",
        "nonce": "LwR5TfqnxBF-wblaNzYhog",
        "address": "3Q8sR3vdrq594rDDswe6Fbs1trMfJqAxCB",
        "public_key": "03db89daffad71964cf354fcb32a960f33c2565b34b7a38bdf9f499edd9294d456",
        "email": "meh@meh.com"
        }
     * @returns 
     */
    // async postWalletUserAuthSign(public_address, body) {
    //     return ApiHelper.post(`${Paths.wallet_user}${public_address}/auth_sign`, body)
    // }
    // async getWalletUserBalance(public_address) {
    //     return ApiHelper.get(`${Paths.wallet_user}${public_address}/balance`, undefined)
    // }
    // async getWalletUserWithdrawQuote(public_address) {
    //     return ApiHelper.get(`${Paths.wallet_user}${public_address}/withdraw_quote`, undefined)
    // }
    /**
   * 
   * @param public_address 
   * @param body 
   *
      {
      "signature": "I68h00eZZuaclK7HD2szOEL6fC2+MnAcpjIjCqkh/ZCtWRviau1t0H41EXYp1SWlHOVW0YxEL7N8/bAoKKDZZMI=",
      "nonce": "LwR5TfqnxBF-wblaNzYhog",
      "address": "3Q8sR3vdrq594rDDswe6Fbs1trMfJqAxCB",
      "public_key": "03db89daffad71964cf354fcb32a960f33c2565b34b7a38bdf9f499edd9294d456",
      "email": "meh@meh.com"
      }
   * @returns 
   */
    // async postWalletUserWithdraw(public_address) {
    //     return ApiHelper.post(`${Paths.wallet_user}${public_address}/withdraw`, undefined)
    // }
    // async postWalletUserWithdrawQuote(public_address) {
    //     return ApiHelper.post(`${Paths.wallet_user}${public_address}/withdraw_quote`, undefined)
    // }
    // ### Login con Privy
    async post_login_privy(privy_token: string, client_id: string) {
        return ApiHelper.post(`${Paths.login_privy}`, { privy_token, client_id })
    }
    // ### Login con Wallet (Obtener Nonce)
    async get_login_auth_nonce(public_address, client_id) {
        return ApiHelper.get(`${Paths.login}/${public_address}/auth_nonce/${client_id}`)
    }
    // ### Login con Wallet (Verificar Firma)
    async post_login_auth_sign(public_address, client_id, body: {
        signature: string,
        nonce: string,
        public_key: string,
        email: string,
    }) {
        return ApiHelper.post(`${Paths.login}/${public_address}/auth_sign/${client_id}`, body)
    }
    // ### Obtener Balance de Wallet
    async get_wallet_user_balance(params: any = undefined) {
        return ApiHelper.get(`${Paths.wallet_user_balance}`, params)
    }
    // ### Obtener Información del Usuario de Wallet
    async get_wallet_user(params: any = undefined) {
        return ApiHelper.get(`${Paths.wallet_user}`, params)
    }
    // ### Obtener Transacciones de Wallet
    async get_wallet_user_transaction(params: any = undefined) {
        return ApiHelper.get(`${Paths.wallet_user_trasaction}`, params)
    }
    // - **Descripción**: Envía un pago a otro usuario
    async post_wallet_user_send_to(send_to: string, quantity: number, order_code: string | undefined = undefined) {
        return ApiHelper.post(`${Paths.wallet_user_send_to}`, { send_to, quantity, order_code })
    }
    // ### Obtener Cotización de Envío
    async post_wallet_user_quote(send_to: string, quantity: number) {
        return ApiHelper.post(`${Paths.wallet_user_quote}/${quantity}/${send_to}`)
    }
    // ### Retirar Fondos a Wallet BTC
    async post_wallet_user_withdraw(public_address: string) {
        return ApiHelper.post(`${Paths.wallet_user}/${public_address}/withdraw`)
    }
     // ### Retirar Fondos a Wallet BTC
    async post_wallet_user_withdraw_quote(public_address: string) {
        return ApiHelper.post(`${Paths.wallet_user}/${public_address}/withdraw_quote`)
    }
}

export default new DataService()